import * as React from 'react';
import config from '@/server/config';
import request from '@/server/request';
import ResearchNav from './nav';
import wechatAuth from './wechatAuth';

export default class ReSearch extends React.Component<any, any> {
    public state = {
        tabIndex: 0, // tab索引
        loadOver: false, // 是否加载全部
        list: [], // 列表数据
        special: '', // 特版
        specialShow: false, // 是否显示特版
    }
    
    private page: number = 1;
    private pageSize: number = 20;
    private isLoading: boolean = false; // 是否加载中
    private loadTimer: any;

    public componentDidMount() { 
        this.getData();
        this.checkSpecial();
        this.setStatus();
        wechatAuth();
        window.addEventListener('scroll', this.scrollAction.bind(this));
    }

    public componentWillUnmount() { 
        window.removeEventListener('scroll', this.scrollAction.bind(this));
    }

    public render() {
        const state = this.state;
        return (
            <section>
                <ResearchNav index={0}></ResearchNav>
                {
                    !state.specialShow ?
                    <div>
                        <ul className="hybg">
                            <li className={state.tabIndex === 0 ? 'current' : ''} onClick={() => this.tabAction(0)}>建筑涂料</li>
                            <li className={state.tabIndex === 1 ? 'current' : ''} onClick={() => this.tabAction(1)}>木器/工业</li>
                            <li className={ state.tabIndex === 2 ? 'current' : '' } onClick={ () => this.tabAction(2)}>涂料原料</li>
                        </ul>
                        <ul className="hybglist">
                            {
                                state.list.map((v: any, k: number) => { 
                                    return (
                                        <li key={ k + '-' + v.id }>
                                            <h3>【{ v.reportTypeName }】</h3>
                                            <span>{ v.releaseTimeStr }</span>
                                            &nbsp; 
                                            <span>&nbsp; { v.reportName }</span>
                                            <a href={ v.reportFileUrl } target="_blank" className="wz">{ v.reportFileName }</a>
                                            <a href={ v.reportFileUrl } className="pdf" target="_blank"><img src={require('@/assets/images/pdf.png')} /></a>
                                            <a href="javascript: void(0)" className="dpwnload" onClick={() => this.downloadPDF(v.reportFileUrl, v.reportFileName)}><img src={require('@/assets/images/download.png')} /></a>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div> : <div className="research-special" dangerouslySetInnerHTML={{__html: state.special}}></div>
                }
            </section>
        )
    }

    // 获取列表数据
    private async getData() { 
        const r = await request({
            url: `${config.API}industry/report/query/subscribe/reports?type=2&typeId=${this.state.tabIndex+1}&pageNum=${this.page}&pageSize=${this.pageSize}`,
        });

        this.isLoading = false;
        if (r.code === 1) { 
            this.setState({
                list: this.state.list.concat(r.obj.list || []),
                loadOver: r.obj.pageNum >= r.obj.pages
            });
        }
    }

    // 检测是否需要显示特版
    private async checkSpecial() { 
        const r = await request({
            url: `${config.API}industry/report/query/subscribe/reports?type=&typeId=`,
        });
        
        if (r.code === 1) { 
            this.setState({
                specialShow: r.obj.total <= 0
            });
            if (r.obj.total <= 0) { 
                this.getSpecial();
            }
        }
    }

    // 获取没有数据时显示的特版
    private async getSpecial() { 
        const r = await request({
            url: `${config.API}api/specialcontent/get?code=005021005001`
        });

        if (r.code === 0) { 
            this.setState({
                special: r.data.formalContent
            });
        }
    }

    /**
     * 切换
     * @param index {number} 索引 0=建筑涂料 1=木器/工业 2=涂料原料
     */
    private tabAction(index: number) { 
        if (this.state.tabIndex === index || this.isLoading) { 
            return;
        }
        this.setState({
            tabIndex: index
        }, () => { 
            this.resetAction()
        });
    }

    // 重制页面数据
    private resetAction() { 
        this.isLoading = true;
        this.page = 1;
        this.setState({
            list: [],
            loadOver: false,
        }, () => { 
                this.getData();
        });
    }

    // 滚动加载
    private scrollAction() { 
        if (this.isLoading || this.state.loadOver) {
            return;
        }

        if (window.pageYOffset + window.innerHeight + 50 > document.body.scrollHeight) {

            if (this.loadTimer) {
                clearTimeout(this.loadTimer);
            }

            this.loadTimer = setTimeout(() => {
                this.loadMore();
            }, 500);

        }
    }

    // 加载更多文章内容
    private loadMore() {
        this.page++;
        this.isLoading = true;
        this.getData();
    }

     // 获取研究院数据
  private setStatus() {
    request({
      url: `${config.API}member/wap/log/lookData/markReadMsg`,
      method: 'post'
    });
  }

  /**
   * [downloadPDF 下载]
   * @param  {[string]} pdfSrc [pdf路径]
   * @param {[string]} fileName [文件名称]
   */
  private downloadPDF(pdfSrc: string, fileName: string) {
      window.location.href = `${config.API}file/download?download=${pdfSrc}&fileName=${fileName}`;
  }
}